<script>
export default {
    name: 'ContentLinkBlock',
    props: {
        data: Object,
    },
};
</script>

<template>
    <div class="link-block">
        <a v-bind:href="data.url" target="_blank" class="link-block__link">
            <svg class="link-block__icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_56_2691" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                <rect width="24" height="24" fill="#D9D9D9"/>
                </mask>
                <g mask="url(#mask0_56_2691)">
                    <path d="M12 4L20 11.9996L12 20" stroke="currentColor"/>
                    <path d="M20 12H4" stroke="currentColor"/>
                </g>
            </svg>
            <span class="link-block__text" v-html="data.text"></span>
        </a>
    </div>
</template>

<style lang="scss">
.link-block {
    margin-top: 3.2rem;
    margin-bottom: 3.2rem;
}

.link-block__link {
    display: inline-flex;
    align-items: flex-start;
    gap: 4.2rem;
    color: $color-secondary-alt;
    text-decoration: none;

    @include breakpoint('xs') {
        gap: 2.4rem;
    }

    &:hover {
        color: $color-secondary;
    }
}

.link-block__icon {
    flex: 0 0 2.4rem;
    margin-top: 0.2rem;

    @include breakpoint('xs') {
        margin-top: 0.3rem;
    }
}

.link-block__text {
    font-size: 1.8rem;
    letter-spacing: 0.032rem;
    line-height: 1.67;
    
}

</style>
